import { CurrencyProps, FieldLabeledProps } from "../../types/fieldTypes";
import NumericField from "../../BaseInputFields/NumericField/NumericField";

export interface CurrencyFieldProps extends CurrencyProps {
  minValue?: number;
  maxValue?: number;
  showIncrementButtons?: boolean;
  stepValue?: number;
  labelProps?: FieldLabeledProps;
}

const CurrencyField: React.FC<CurrencyFieldProps> = (props) => {
  return (
    <NumericField
      className="currency-field"
      type="Numeric"
      description={props.description}
      label={props.label}
      format="c2"
      currency="USD"
      min={props.minValue}
      max={props.maxValue}
      showIncrementButtons={props.showIncrementButtons}
      stepValue={props.stepValue}
      placeholder={props.placeholder ?? "$1.00"}
      value={props.value}
      disabled={props.disabled}
      onSubmit={props.onSubmit}
      errorMessages={props.errorMessages}
      isRequired={props.isRequired}
      labelProps={props.labelProps}
    />
  );
};

export default CurrencyField;
